// extracted by mini-css-extract-plugin
module.exports = {"centered":"content-module--centered--LUv0z"};